__webpack_require__.p = "https://staging-suite.mymalls.com/packs/";